
import ProductInventories from '~/components/products/ProductInventories'

export default {
  components: {
    ProductInventories
  },
  props: {
    productSlug: {
      type: String,
      required: true
    }
  },
  watch: {
    '$route' (to, from) {
      this.$emit('close')
    }
  }
}
